<template>
    <section class="container" id="schedule" v-if="hasLoaded">
        <h1>Raspored</h1>
        
        <section class="main">
            <aside class="schedule-menu">
                <div>
                    <div>
                        <button class="active" v-on:click="toggleDay(0)">Petak (1. dan)</button>
                    </div>
                    <div>
                        <button v-on:click="toggleDay(1)">Subota (2. dan)</button>
                    </div>
                </div>
                <div class="schedule-type">
                    <label>
                        Predavanja
                        <input type="radio" class="type-radio" checked="checked" name="type-radio" v-on:click="showScheduleContainer(0)" />
                        <span class="radio-button"></span>
                    </label>
                    <label>
                        Radionice
                        <input type="radio" class="type-radio" name="type-radio" v-on:click="showScheduleContainer(1)" />
                        <span class="radio-button"></span>
                    </label>
                    <label>
                        Campfire talks
                        <input type="radio" class="type-radio" name="type-radio" v-on:click="showScheduleContainer(2)" />
                        <span class="radio-button"></span>
                    </label>
                </div>
            </aside>

            <section class="schedule-container">
                <section class="schedule-item-container active">
                    <template v-if="shownEvents.hasOwnProperty('Lecture') && shownEvents.Lecture.length">
                        <template v-for="event in shownEvents.Lecture">
                            <Event v-bind:event="event" v-bind:key="event.id" />
                        </template>
                    </template>
                </section>

                <section class="schedule-item-container">
                    <template v-if="shownEvents.hasOwnProperty('Workshop') && shownEvents.Workshop.length">
                        <template v-for="event in shownEvents.Workshop">
                            <Event v-bind:event="event" v-bind:key="event.id" />
                        </template>
                    </template>
                </section>

                <section class="schedule-item-container">
                    <template v-if="shownEvents.hasOwnProperty('CampfireTalk') && shownEvents.CampfireTalk.length">
                        <template v-for="event in shownEvents.CampfireTalk">
                            <Event v-bind:event="event" v-bind:key="event.id" />
                        </template>
                    </template>
                </section>
            </section>    
        </section>
    </section>
</template>

<script>
    import Event from '@/components/landing-page/Event.vue';
    import { groupBy } from '@/config';

    export default {
        name: 'EventList',
        data() {
            return {
                distinctDays: [],
                events: {},
                shownEvents: {},
                hasLoaded: false
            }
        },
        components: {
            Event
        },
        methods: {
            toggleDay: function(dayNumber) {
                let buttons = document.querySelectorAll('.schedule-menu button');

                for(let button of buttons)
                    button.classList.remove('active');

                buttons[dayNumber].classList.add('active');

                this.filterShownEvents(dayNumber);
            },
            filterShownEvents: function(dayNumber) {
                for(let category in this.shownEvents)
                    this.shownEvents[category] = 
                        this.events[category].filter(event => new Date(event.starts).getDate() === this.distinctDays[dayNumber] );
            },
            showScheduleContainer: function(indexOfContainerToShow) {
                let scheduleItemContainers = document.querySelectorAll('.schedule-item-container');

                for (let container of scheduleItemContainers)
                    container.classList.remove('active');

                scheduleItemContainers[indexOfContainerToShow].classList.add('active');
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/events/events-for-schedule`).then(response => {
                this.distinctDays = 
                    [...new Set(response.data.map(event => new Date(event.starts).getDate()))].sort();
                this.events = groupBy(response.data, 'type');
                this.shownEvents = Object.assign({}, this.events);
                this.filterShownEvents(0);
                this.hasLoaded = true;
            });
        }
    }
</script>

<style scoped>
section > h1 {
    margin-top: 100px;
    color: #001618;
    font-weight: 800;
    line-height: 44px;
    font-size: 54px;
    margin-bottom: 50px;
    margin-left: 19%;
}

.main {
    display: flex;
}

.schedule-menu {
    width: 15%;
}

.schedule-container {
    width: 85%;
}

.schedule-item-container {
    display: none;
}

.schedule-item-container.active {
    display: block;
}

button {
    height: 50px;
    width: 150px;
    box-shadow: 0 1px 9px 0 rgba(0,0,0,0.17);
    background-color: white;
    border: none;
    color: #2C373F;
    font-size: 14px;
    margin-bottom: 10px;
}

button:hover {
    cursor: pointer;
}

button.active {
    background-color: #30cec1;
    color: white;
}

.schedule-container {
    margin-left: 5%;
}

.schedule-container div.schedule-item:not(:first-of-type) {
    margin-top: 50px;
}

.schedule-type {
    position: relative;
    margin-top: 20px;
}

.schedule-type label {
    display: block;
    margin-top: 5px;
    position: relative;
    cursor: pointer;
    padding-left: 25px;
}

.schedule-type label input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.radio-button {
    position: absolute;
    margin-right: 10px;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    border: 1px solid #30cec1;
    background-color: white;
    border-radius: 50%;
}

.schedule-type label:hover input ~ .radio-button {
    background-color: rgba(0,0,0,0.05);
}

.schedule-type label input:checked ~ .radio-button {
    background-color: white;
}

.radio-button:after {
  content: "";
  position: absolute;
  display: none;
}

.schedule-type input:checked ~ .radio-button:after {
    display: block;
}

.schedule-type .radio-button:after {
    top: 5px;
    left: 5px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #30cec1;
}

@media screen and (max-width: 1250px) {
    section > h1 {
        margin-left: 23%;
    }

    .schedule-menu {
        width: 20%;
    }
}

@media screen and (max-width: 1024px) {
    section > h1 {
        margin-left: 24%;
    }
}

@media screen and (max-width: 850px) {
    section > h1 {
        margin-left: 5%;
    }

    .main {
        flex-direction: column;
    }

    .schedule-menu {
        width: 100%;
        display: flex;
        margin-left: 5%;
        margin-bottom: 20px;
    }

    .schedule-menu div:first-of-type {
        margin-right: 20px;
    }

    section > h1 {
        margin-left: 0;
    }

    .schedule-container {
        margin-left: 0;
        width: 100%;
    }

    .schedule-menu {
        margin-left: 0;
    }
}

@media screen and (max-width: 768px) {
    section > h1 {
        font-size: 36px;
    }
}

@media screen and (max-width: 700px) {
    section > h1 {
        margin-left: -5%;
    }

    .schedule-container {
        width: 110%;
        margin-left: -5%;
    }

    .schedule-menu {
        margin-left: -5%;
    }
}

@media screen and (max-width: 450px) {
    .schedule-menu div:first-of-type {
        margin-right: 5px;
    }
}
</style>